import Vue from 'vue';
import moment from 'moment'
import settings from '../modules/settings'

export default {

    configure: () => {

        Vue.filter('localDate', (value) => {

            if (!value) return '';

            var dateFormat = settings.user.getDateFormat();
            
            return moment.utc(value).local().format(dateFormat);
        });

        Vue.filter('localDateTime', (value) => {

            if (!value) return '';

            var dateFormat = settings.user.getDateFormat();
            var timeFormat = settings.user.getTimeFormat();

            return moment.utc(value).local().format(dateFormat + ' ' + timeFormat);
        });
    }
}